import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  PROVIDER_FORM_FIELD_NAME_NAME,
  PROVIDER_FORM_NAME_FIELD_MAX_LENGTH,
} from '../../ProviderForm.constants'

function NameField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Provider.NameFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={PROVIDER_FORM_NAME_FIELD_MAX_LENGTH}
      name={PROVIDER_FORM_FIELD_NAME_NAME}
      placeholder={t('Provider.NameFieldPlaceholderKey')}
    />
  )
}

export default NameField
